import { IList } from "constants/common";

export interface IDashboard extends IList {
  total: any;
  params: {
    page: number;
    limit: number;
    search: string;
  };
}

export enum Types {
  CHANGE_PARAMS = "[DASHBOARD] CHANGE PARAMS",
  SET_DATA = "[DASHBOARD] SET_DATA",
  LOAD_DATA = "[DASHBOARD] LOAD_DATA",
  SET_LOADING = "[DASHBOARD] SET_LOADING",
  CLEAR_STATE = "[DASHBOARD] CLEAR_STATE",
}

export interface ClearStateAction {
  type: typeof Types.CLEAR_STATE;
}

export interface SetLoadingAction {
  type: typeof Types.SET_LOADING;
  payload: {
    loading: boolean;
  };
}

export interface ChangeParamsAction {
  type: typeof Types.CHANGE_PARAMS;
  payload: {
    params: any;
  };
}

export interface LoadDataAction {
  type: typeof Types.LOAD_DATA;
  payload: {
    params: any;
  };
}

export interface SetDataAction {
  type: typeof Types.SET_DATA;
  payload: { data: any[]; total: any; count: number };
}

export type Actions =
  | ClearStateAction
  | SetDataAction
  | LoadDataAction
  | ChangeParamsAction
  | SetLoadingAction;
